import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Icon } from './Icons.jsx';
import MarketingSubnav from './MarketingSubnav.jsx';

export default function PostingFeatureLock({ section }) {
  const { t } = useTranslation();
  return (
    <div className="posting-lock">
      <MarketingSubnav />
      <div className="posting-lock__preview" aria-hidden="true">
        <span className="posting-lock__line posting-lock__line--title" />
        <span className="posting-lock__line" />
        <span className="posting-lock__line posting-lock__line--short" />
        <div className="posting-lock__grid"><span /><span /><span /></div>
      </div>
      <section className="posting-lock__card" aria-labelledby="posting-lock-title">
        <span className="posting-lock__icon"><Icon name="lock" size={20} /></span>
        <div>
          <p className="posting-lock__eyebrow">{t(section === 'marketing' ? 'postingWorkspace.marketIntelligence' : 'postingWorkspace.contentPlan')}</p>
          <h1 id="posting-lock-title">{t('postingWorkspace.lockTitle')}</h1>
          <p>{t('postingWorkspace.lockBody')}</p>
          <Link className="btn btn-primary" to="/app/plans">{t('postingWorkspace.upgradeCta')}</Link>
        </div>
      </section>
    </div>
  );
}
